import axios from "axios";
import Config from "../config/config";

axios.interceptors.request.use(
  async (evt) => {
    if (checkTokenNeed(evt.url)) {
      const storedToken = await localStorage.getItem("token");
      const token = storedToken;
      if (token) {
        evt.headers.Authorization = token;
        return evt;
      } else {
        document.location.href="/";
        throw new Error("session Expire");
      }
    }
    return evt;
  }, 
   (err) => Promise.reject(err)
);

// Add a response interceptor
axios.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  if (error.response.status === 401) {
    //localStorage.clear();
    localStorage.removeItem('logout');
    localStorage.removeItem('token');
    localStorage.removeItem('email');
    localStorage.removeItem("CognitoIdentityServiceProvider.7crnf0pbvktbhdf878b5cobn5n.rajeev.idToken");
    localStorage.removeItem("CognitoIdentityServiceProvider.7crnf0pbvktbhdf878b5cobn5n.rajeev.accessToken");
    localStorage.removeItem("CognitoIdentityServiceProvider.7crnf0pbvktbhdf878b5cobn5n.rajeev.refreshToken");
    localStorage.removeItem("CognitoIdentityServiceProvider.7crnf0pbvktbhdf878b5cobn5n.rajeev.clockDrift");
    localStorage.removeItem("CognitoIdentityServiceProvider.7crnf0pbvktbhdf878b5cobn5n.LastAuthUser");
    localStorage.removeItem("token");
    localStorage.removeItem("email");
    localStorage.removeItem("username");
    sessionStorage.clear();
    document.location.href="/";
  }
  return Promise.reject(error);
});


const checkTokenNeed = (url) =>
url.includes(Config.leadList)||
url.includes(Config.applicationList) ||
url.includes(Config.applicationDetails)||
url.includes(Config.componentDetails)||
url.includes(Config.getUserProfile) ||
url.includes(Config.partnerDetails)||
url.includes(Config.documentList)||
url.includes(Config.addPartner) || 
url.includes(Config.dmsMapping) || 
url.includes(Config.addDocumentCode) ||
url.includes(Config.breRejectedList) ||
url.includes(Config.partnerHistory) ||
url.includes(Config.esignList) ||
url.includes(Config.queueProductVerification) ||
url.includes(Config.addDms) || 
url.includes(Config.finTechType) ||
url.includes(Config.paymentLog) ||
url.includes(Config.dashboard) ||
url.includes(Config.finTypes) ||
url.includes(Config.insertFinType) ||
url.includes(Config.finTypeHistory) ||
url.includes(Config.finTypeHistory) ||
url.includes(Config.getPartnerFullList) ||
url.includes(Config.downloadLeadList) ||
url.includes(Config.getUtrFromLan) ||
url.includes(Config.utrOperation) ||
url.includes(Config.utrHistory) ||
url.includes(Config.resetNotificaiton) ||
url.includes(Config.getLanNo);

export default axios;
